/* Artifact elements — special items rendered on/near the kiwi. */

import type { KiwiPalette } from "../kiwiPalettes";
import type { Artifact } from "@/types/kiwiSkin";

export function renderArtifact(palette: KiwiPalette, artifact: Artifact) {
  switch (artifact) {
    case "golden_crown":
      return (
        <>
          <rect x="10" y="2" width="2" height="2" fill="#ffd54f" />
          <rect x="14" y="0" width="2" height="2" fill="#ffd54f" />
          <rect x="18" y="2" width="2" height="2" fill="#ffd54f" />
          <rect x="10" y="4" width="12" height="2" fill="#ffd54f" />
          {/* Gem on crown */}
          <rect x="15" y="1" width="1" height="1" fill="#e53935" opacity={0.8} />
        </>
      );
    case "flaming_sword":
      return (
        <>
          {/* Blade */}
          <rect x="26" y="6" width="2" height="8" fill={palette.accent} opacity={0.6} />
          <rect x="27" y="4" width="1" height="2" fill={palette.accent} opacity={0.5} />
          {/* Hilt */}
          <rect x="24" y="14" width="6" height="2" fill={palette.beak} opacity={0.7} />
          <rect x="26" y="16" width="2" height="4" fill={palette.beak} opacity={0.5} />
          {/* Flame on blade */}
          <rect x="28" y="6" width="1" height="2" fill="#ff6f00" opacity={0.5} />
          <rect x="25" y="8" width="1" height="2" fill="#ff6f00" opacity={0.4} />
          <rect x="28" y="10" width="1" height="1" fill="#ff6f00" opacity={0.3} />
        </>
      );
    case "crystal_orb":
      return (
        <>
          {/* Orb body */}
          <rect x="26" y="16" width="4" height="4" fill={palette.accent} opacity={0.4} />
          <rect x="27" y="15" width="2" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="27" y="20" width="2" height="1" fill={palette.accent} opacity={0.3} />
          {/* Inner glow */}
          <rect x="27" y="17" width="2" height="2" fill={palette.highlight} opacity={0.5} />
          {/* Sparkle on orb */}
          <rect x="27" y="16" width="1" height="1" fill="#ffffff" opacity={0.6} />
        </>
      );
    case "ancient_scroll":
      return (
        <>
          {/* Scroll body */}
          <rect x="26" y="14" width="4" height="8" fill={palette.eyeBg} opacity={0.5} />
          {/* Scroll ends (rolled) */}
          <rect x="25" y="14" width="6" height="2" fill={palette.beak} opacity={0.5} />
          <rect x="25" y="20" width="6" height="2" fill={palette.beak} opacity={0.5} />
          {/* Text lines */}
          <rect x="27" y="17" width="2" height="1" fill={palette.pupil} opacity={0.2} />
          <rect x="27" y="19" width="2" height="1" fill={palette.pupil} opacity={0.15} />
        </>
      );
    case "diamond_ring":
      return (
        <>
          {/* Ring band */}
          <rect x="0" y="18" width="4" height="2" fill={palette.accent} opacity={0.5} />
          <rect x="0" y="16" width="1" height="2" fill={palette.accent} opacity={0.4} />
          <rect x="3" y="16" width="1" height="2" fill={palette.accent} opacity={0.4} />
          {/* Diamond */}
          <rect x="1" y="14" width="2" height="2" fill="#b3e5fc" opacity={0.7} />
          {/* Diamond sparkle */}
          <rect x="0" y="13" width="1" height="1" fill="#ffffff" opacity={0.5} />
          <rect x="3" y="13" width="1" height="1" fill="#ffffff" opacity={0.3} />
        </>
      );
    case "cyber_visor":
      return (
        <>
          {/* Visor across eye area */}
          <rect x="8" y="9" width="12" height="4" fill={palette.accent} opacity={0.35} />
          {/* Visor glow line */}
          <rect x="8" y="10" width="12" height="1" fill={palette.highlight} opacity={0.5} />
          {/* Side frames */}
          <rect x="6" y="10" width="2" height="2" fill={palette.accent} opacity={0.3} />
          <rect x="20" y="10" width="2" height="2" fill={palette.accent} opacity={0.3} />
        </>
      );
    default:
      return null;
  }
}
